import React from "react";
import "../../CSS/Industries.css";

function FinanceAccounting() {
    return (
        <>
            
            <section
                className="industry-detail-hero"
                style={{ backgroundColor: '#002952' }}
            >
                <div className="container">
                    <div className="industry-detail-hero-content">
                        <h1>Solutions for Finance & Accounting</h1>
                        <p style={{ color: '#FF7D37' }}>
                            Build reliable digital systems that help finance and
                            accounting organizations manage information,
                            workflows, reporting, and business operations.
                        </p>
                    </div>
                </div>
            </section>


            <section className="industry-detail-section">
                <div className="container">

                    <div className="row align-items-center g-5">

                        <div className="col-lg-6">
                            <h2>
                                Simplify Financial Operations
                            </h2>

                            <p>
                                Financial organizations require accurate,
                                secure, and efficient technology systems.
                            </p>

                            <p>
                                We develop customized applications and
                                business systems to support accounting,
                                reporting, workflow management, and
                                financial operations.
                            </p>
                        </div>

                        <div className="col-lg-6">
                            <img
                                src="/images/home/finance.png"
                                alt="Finance and Accounting Solutions"
                                className="industry-detail-image"
                            />
                        </div>

                    </div>

                </div>
            </section>


            <section className="industry-features">
                <div className="container">

                    <div className="section-heading text-center">
                        <h2>Solutions for<br /> Finance & Accounting</h2>
                    </div>

                    <div className="industry-feature-grid">

                        <div className="industry-feature-card">
                            <i className="bi bi-calculator"></i>
                            <h3>Accounting Systems</h3>
                            <p>Custom systems to support accounting and financial workflows.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-file-earmark-text"></i>
                            <h3>Financial Reports</h3>
                            <p>Organized reporting solutions for business information.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-graph-up"></i>
                            <h3>Business Analytics</h3>
                            <p>Dashboards and analytics to support business decisions.</p>
                        </div>

                        <div className="industry-feature-card">
                            <i className="bi bi-shield-check"></i>
                            <h3>Secure Applications</h3>
                            <p>Technology solutions designed with security and access control in mind.</p>
                        </div>

                    </div>
                </div>
            </section>

        </>
    );
}

export default FinanceAccounting;